class EsiGeo {
	constructor() {
		let zip = this.getValueById('esi_geo_zip');
		this.zip = zip ? zip.substring(0, 5) : null;
	}

	getValueById(id) {
		let element = document.getElementById(id);

		if (!element || !element.innerHTML || element.innerHTML[0] === '$') return null;

		return element.innerHTML;
	}
}

export default new EsiGeo();



// WEBPACK FOOTER //
// ./assets/components/fsUtils/EsiGeo.js